import { Facebook, Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0C] border-t border-white/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <Link to="/" className="h-display text-3xl text-white">
              ROAD<span className="text-[#F47A20]">RIG</span>
            </Link>
            <p className="mt-4 text-white/50 max-w-sm leading-relaxed">
              Premium motorcycle luggage. Built by one stubborn rider. Designed for thousands more.
            </p>
            <div className="mt-6 serial text-[10px] text-white/40">
              ROADRIG AUSTRALIA · ESTABLISHED 2026
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Navigate</div>
            <ul className="space-y-3 text-sm text-white/70">
              <li><a href="#hero" className="hover:text-[#F47A20]">Home</a></li>
              <li><a href="#founder" className="hover:text-[#F47A20]">Founder</a></li>
              <li><a href="#journey" className="hover:text-[#F47A20]">Journey</a></li>
              <li><Link to="/journal" className="hover:text-[#F47A20]">Journal Archive</Link></li>
              <li><Link to="/press" className="hover:text-[#F47A20]">Press & Founder Kit</Link></li>
              <li><a href="#outlaw-teaser" className="hover:text-[#F47A20]">The OUTLAW V1</a></li>
              <li><a href="#vip" className="hover:text-[#F47A20]">VIP Waitlist</a></li>
              <li><Link to="/coming-soon" className="hover:text-[#F47A20]">VIP Access</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4">Contact</div>
            <a
              href="mailto:hello@roadrig.com.au"
              data-testid="footer-email-link"
              className="flex items-center gap-3 text-white hover:text-[#F47A20] transition-colors mb-6"
            >
              <Mail size={16} />
              hello@roadrig.com.au
            </a>

            <div className="overline mb-4">Follow the ride</div>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="https://instagram.com/roadrig.au"
                target="_blank"
                rel="noreferrer"
                data-testid="social-instagram"
                className="inline-flex items-center gap-2 px-3 py-2 border border-white/10 rounded-sm text-white/70 hover:text-[#F47A20] hover:border-[#F47A20]/40 transition-all"
              >
                <Instagram size={16} />
                <span className="serial text-[11px] tracking-[0.15em] uppercase font-bold">@roadrig.au</span>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61591062287084"
                target="_blank"
                rel="noreferrer"
                data-testid="social-facebook"
                className="inline-flex items-center gap-2 px-3 py-2 border border-white/10 rounded-sm text-white/70 hover:text-[#F47A20] hover:border-[#F47A20]/40 transition-all"
              >
                <Facebook size={16} />
                <span className="serial text-[11px] tracking-[0.15em] uppercase font-bold">Facebook</span>
              </a>
            </div>
            <p className="serial text-[10px] text-white/35 mt-3 max-w-xs leading-relaxed">
              More channels rolling out soon.
            </p>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between gap-4 items-start md:items-center">
          <div className="serial text-[10px] text-white/40">
            © {new Date().getFullYear()} ROADRIG AUSTRALIA · ALL RIGHTS RESERVED
          </div>
          <div className="serial text-[10px] text-white/30">
            BUILT BY ONE STUBBORN RIDER · DESIGNED FOR THOUSANDS MORE
          </div>
        </div>
      </div>
    </footer>
  );
};
